import { render, staticRenderFns } from "./Settle.vue?vue&type=template&id=b53a9af2&scoped=true&"
import script from "./Settle.vue?vue&type=script&lang=js&"
export * from "./Settle.vue?vue&type=script&lang=js&"
import style0 from "./Settle.vue?vue&type=style&index=0&id=b53a9af2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53a9af2",
  null
  
)

export default component.exports